/* eslint-disable react-hooks/exhaustive-deps */
import { Font } from "@react-pdf/renderer";
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../../../assets/fonts/rudawregular2.ttf';
import PostService from '../../../../services/postService';
import { useCompany } from '../../../../provider/companyProvider';
import { wrap } from 'comlink';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
import JsBarcode from "jsbarcode";



// ✅ Modern worker import (Webpack 5 / Vite)
const worker = new Worker(new URL('./pdfDriverPostListWorker.js', import.meta.url));
const workerApi = wrap(worker);

const registerFont = () => {
  Font.register({
    family: 'Rudaw',
    fonts: [{ src: Rudaw, fontWeight: 'normal' }],
  });
};


const PdfDriverPostList = ({ data }) => {
  const { i18n, t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const handlePrint = async () => {
    registerFont();
    setIsLoading(true);

    setIsLoading(true);
    const filters = data && {
      name: data.name,
      streetId: data.streetId,
      cityId: data.cityId,
      driverId: data.driverId,
      branch: data.branch && data.branch.id,
      pageId: data.pageId,
      postStatusId: data.postStatusId,
      type: data.type,
      isPagePaid: data.isPagePaid,
      isDriverPaid: data.isDriverPaid,
      ...data.time,
      ...data.sort,
      ids: data.ids
    };

    console.log({ filters });

    try {
      // Fetch data
      const response = await PostService.fetchByDriver(filters);
      const responseData = response;

      const generateBarcodeBase64 = (text) => {
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, text, { format: 'CODE128', displayValue: false });
        return canvas.toDataURL('image/png');
      };

      // Map barcodes for all posts
      const postsWithBarcode = responseData.posts.map(post => ({
        ...post,
        barcodeBase64: generateBarcodeBase64(post.id)
      }));

      const translations = {
        driverReport: t('driverReport'),
        number: t('number'),
        id: t('id'),
        driver: t('driver'),
        phone: t('phone'),
        time: t('time'),
        branch: t('branch'),
        receiverPhoneTable: t('receiverPhoneTable'),
        amount: t('amount'),
        itemType: t('itemType'),
        type: t('type'),
        pageName: t('pageName'),
        pagePhoneTable: t('pagePhoneTable'),
        address: t('address'),
        note: t('note'),
        barcode: t('barcode'),
        totalItems: t('totalItems'),
        totalPostAmount: t('totalPostAmount'),
        totalDriverAmount: t('totalDriverAmount'),
        netPostAmount: t('netPostAmount'),
        new: t('new'),
        change: t('change'),
        today: t('today'),
        week: t('week'),
        month: t('month'),
        custom: t('custom'),
        yesterday: t('yesterday'),
        daybeforeyesterday: t('daybeforeyesterday')
      };

      // Generate PDF
      const blobUrl = await workerApi.renderPDF({
        branch: data.branch,
        time: data.time,
        business,
        responseData: { ...responseData, posts: postsWithBarcode },
        t: translations,
        language: i18n.language,
      });
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading
    ? <CircularProgress size={20} />
    : <DriveEtaOutlinedIcon sx={{ cursor: 'pointer' }} fontSize='small' onClick={handlePrint} />;
};

export default PdfDriverPostList;